<template>
  <div>
    <progress-pic></progress-pic>

    <el-row :gutter="30" class="progress-pic">
      <el-col :span="8">
        <div class="compliance-box stat-box">
         <h1 class="title">COMPLIANCE</h1>
         <span class="value">86%</span>
        </div>
        <div class="streak-box stat-box">
          <h1 class="title">LONGEST STREAK</h1>
          <span class="value">12 Days</span>
        </div>
      </el-col>
      <el-col :span="16">
        <div class="compliance-chart-container">
          <div class="compliance-row">
             <div class="week-title">Week 1</div>
             <div class="checkin-marker completed"><i></i></div>
             <div class="checkin-marker completed"><i></i></div>
             <div class="checkin-marker completed"><i></i></div>
             <div class="checkin-marker completed"><i></i></div>
             <div class="checkin-marker failed"><i></i></div>
             <div class="checkin-marker failed"><i></i></div>
             <div class="checkin-marker completed"><i></i></div>
          </div>
          <div class="compliance-row">
             <div class="week-title">Week 2</div>
             <div class="checkin-marker completed"><i></i></div>
             <div class="checkin-marker completed"><i></i></div>
             <div class="checkin-marker completed"><i></i></div>
             <div class="checkin-marker completed"><i></i></div>
             <div class="checkin-marker completed"><i></i></div>
             <div class="checkin-marker completed"><i></i></div>
             <div class="checkin-marker completed"><i></i></div>
          </div>
          <div class="compliance-row">
             <div class="week-title">Week 3</div>
             <div class="checkin-marker completed"><i></i></div>
             <div class="checkin-marker completed"><i></i></div>
             <div class="checkin-marker completed"><i></i></div>
             <div class="checkin-marker completed"><i></i></div>
             <div class="checkin-marker failed"><i></i></div>
             <div class="checkin-marker  completed"><i></i></div>
             <div class="checkin-marker completed"><i></i></div>
          </div>
          <div class="compliance-row">
             <div class="week-title">Week 4</div>
             <div class="checkin-marker completed"><i></i></div>
             <div class="checkin-marker completed"><i></i></div>
             <div class="checkin-marker failed"><i></i></div>
             <div class="checkin-marker  completed"><i></i></div>
             <div class="checkin-marker"><i></i></div>
             <div class="checkin-marker"><i></i></div>
             <div class="checkin-marker"><i></i></div>
          </div>
          <div class="compliance-row">
             <div class="week-title">Week 5</div>
             <div class="checkin-marker"><i></i></div>
             <div class="checkin-marker"><i></i></div>
             <div class="checkin-marker"><i></i></div>
             <div class="checkin-marker"><i></i></div>
             <div class="checkin-marker"><i></i></div>
             <div class="checkin-marker"><i></i></div>
             <div class="checkin-marker"><i></i></div>
          </div>
          <div class="compliance-row">
             <div class="week-title">Week 6</div>
             <div class="checkin-marker"><i></i></div>
             <div class="checkin-marker"><i></i></div>
             <div class="checkin-marker"><i></i></div>
             <div class="checkin-marker"><i></i></div>
             <div class="checkin-marker"><i></i></div>
             <div class="checkin-marker"><i></i></div>
             <div class="checkin-marker"><i></i></div>
          </div>
          <div class="compliance-row">
             <div class="week-title">Week 7</div>
             <div class="checkin-marker"><i></i></div>
             <div class="checkin-marker"><i></i></div>
             <div class="checkin-marker"><i></i></div>
             <div class="checkin-marker"><i></i></div>
             <div class="checkin-marker"><i></i></div>
             <div class="checkin-marker"><i></i></div>
             <div class="checkin-marker"><i></i></div>
          </div>
          <div class="compliance-row">
             <div class="week-title">Week 8</div>
             <div class="checkin-marker"><i></i></div>
             <div class="checkin-marker"><i></i></div>
             <div class="checkin-marker"><i></i></div>
             <div class="checkin-marker"><i></i></div>
             <div class="checkin-marker"><i></i></div>
             <div class="checkin-marker"><i></i></div>
             <div class="checkin-marker"><i></i></div>
          </div>
          <div class="compliance-row">
             <div class="week-title">Week 9</div>
             <div class="checkin-marker"><i></i></div>
             <div class="checkin-marker"><i></i></div>
             <div class="checkin-marker"><i></i></div>
             <div class="checkin-marker"><i></i></div>
             <div class="checkin-marker"><i></i></div>
             <div class="checkin-marker"><i></i></div>
             <div class="checkin-marker"><i></i></div>
          </div>
          <div class="compliance-row">
             <div class="week-title">Week 10</div>
             <div class="checkin-marker"><i></i></div>
             <div class="checkin-marker"><i></i></div>
             <div class="checkin-marker"><i></i></div>
             <div class="checkin-marker"><i></i></div>
             <div class="checkin-marker"><i></i></div>
             <div class="checkin-marker"><i></i></div>
             <div class="checkin-marker"><i></i></div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import ProgressPic from './progress-pic-uploader.vue';

export default {
  name: 'progress',
  components: {ProgressPic},
  data () {
    return {
      savingData: false,
      msg: 'This is the login',
      userData:{
        email:"",
        password:""
      }
    }
  },
  methods:{
    onSubmitWeight:function(){
      this.$router.push('/signup/plan');
    }
  }
}
</script>

<style>
.compliance-box{
  width: 100%;
  background-color: #FFF;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  height: 160px;
  margin-bottom: 30px;
}
.stat-box{
  width: 100%;
  background-color: #FFF;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  height: 130px;
}
.stat-box .title {
  font-family: 'prohibition';
  font-size: 26px;
  margin-top: 0;
  padding: 10px 20px 0;
  width: 100%;
  text-align: left;
  display: inline-block;
  color: #999999;
  margin-bottom: 0;
}
.stat-box .value{
  color: #D70073;
  font-size: 68px;
  line-height: 68px;
  width: 100%;
  text-align: left;
  padding: 0 20px;
  font-family: 'prohibition';
  display: inline-block;
  box-sizing: border-box;
} 

.compliance-chart-container{
  width: 100%;
  background-color: #FFF;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  padding: 10px 0;
}
.compliance-row {
  width: 100%;
  display: flex;
  box-sizing: border-box;
  padding: 10px 10px 5px 0;
}
.compliance-row div{
  flex-grow: 1;
}
.compliance-row div.week-title{
  width: 100px;
  text-align: center;
  font-family: prohibition;
  color: #999;
  font-size: 26px;
}

.checkin-marker i{
  background-color: #CCC;
  width: 15px;
  height: 15px;
  margin-top: 10px;
  border-radius: 100%;
  display: inline-block;
}
.checkin-marker.failed i{
  background-color: #EB4C60;
}
.checkin-marker.completed i{
  background-color: #76CE5A;
}
</style>
